/**
 * Utility function to scroll to the top of the page
 * @param {Object} options - Scrolling options
 * @param {string} options.behavior - The scrolling behavior ('auto' or 'smooth')
 */
export const scrollToTop = (options = { behavior: 'smooth' }) => {
  window.scrollTo({
    top: 0,
    left: 0,
    ...options
  });
};
